import CitySEOHead from "@/components/feature/CitySEOHead";
import BristolHeroSection from "./components/HeroSection";
import BristolStickyNav from "./components/StickyNav";
import BristolProcessingTimeSection from "./components/ProcessingTimeSection";
import BristolFAQSection, { faqs } from "./components/FAQSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { bristolConfig } from "./data";

const pageTitle = "Emergency Passport Bristol, TN — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Bristol, TN — as fast as 24 hours. A+ BBB rated registered courier serving NASCAR crew, King University, Tri-Cities, and all Northeast Tennessee. No 290-mile drive to Nashville required.";

export default function BristolPage() {
  const c = bristolConfig;
  return (
    <>
      <CitySEOHead
        city="Bristol"
        state="Tennessee"
        stateAbbr="TN"
        route="/cities/bristol"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bristol, Tennessee"
        geoPosition="36.5951;-82.1887"
        keywords="expedited passport Bristol, emergency passport Bristol TN, same day passport Bristol, fast passport Tennessee, passport renewal Bristol, Tri-Cities passport, NASCAR passport"
        faqs={faqs}
        servicesSchema={c.servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Bristol — we serve this area remotely."
      />
      <div className="font-sans">
        <BristolHeroSection />
        <BristolStickyNav />
        <BristolProcessingTimeSection />
        <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
        <CityLocalAreaSection city={c.city} state={c.state} cities={c.nearbyCitiesZips} benefits={c.benefits} internalLinks={c.internalLinks} officeNote={c.fpcOfficeNote} officeDistance={c.fpcOfficeDistance} officeAddress={c.fpcOfficeAddress} serviceAreaIntro={c.serviceAreaIntro} nearbyCitiesIntro={c.nearbyCitiesIntro} />
        {c.travelTiming && <CityTravelTimingSection city={c.city} data={c.travelTiming} />}
        {c.destinations && <CityDestinationsSection city={c.city} data={c.destinations} />}
        <CityTestimonialsSection city={c.city} testimonials={c.testimonials} intro={c.testimonialsIntro} />
        <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
        <CityComparisonSection city={c.city} regionalAgency={c.regionalAgency} rows={c.comparisonRows} />
        <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
        <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
        <BristolFAQSection />
        <CityHelpfulResourcesSection city={c.city} state={c.state} photoLocations={c.photoLocations} dmvLocations={c.dmvLocations} airports={c.airports} dmvWebsite={c.dmvWebsite} dmvLabel={c.dmvLabel} />
        <SEOCrossLinks currentRoute="/cities/bristol" state="TN" />
        <CityFinalCTA />
      </div>
    </>
  );
}